export default __webpack_public_path__ + "static/Values-bf79d30aa9d9b3cc712568634f730a9c.webp";